/*
 * Public API Surface of the rule based root entry point
 */

export * from './index';
